import { create } from 'zustand'
import type { UserMe } from '@/types/api'

const TOKEN_KEY = 'lts_access_token'

interface AuthState {
  user: UserMe | null
  isAuthenticated: boolean
  setUser: (user: UserMe) => void
  login: (user: UserMe, token: string) => void
  logout: () => void
  getToken: () => string | null
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: !!localStorage.getItem(TOKEN_KEY),

  setUser: (user) => set({ user, isAuthenticated: true }),

  login: (user, token) => {
    localStorage.setItem(TOKEN_KEY, token)
    set({ user, isAuthenticated: true })
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY)
    set({ user: null, isAuthenticated: false })
  },

  getToken: () => localStorage.getItem(TOKEN_KEY),
}))
